module.exports = __webpack_public_path__ + "static/media/vario-gebaeude-dark.11eee706.jpg";